import { mainNum } from '../constants'

const threeRatio = 3
const fourRatio = 4
const threeToFourRatio = threeRatio / fourRatio
const oneToOneRatio = 1 / 1

const validates = {
    item_images: {
        name: 'item_images',
        validate: {
            name: '商品图片',
            validatorNum: mainNum,
            sizeValidator: {
                minSize: 0,
                maxSize: 5
            },
            rectValidator: {
                maxWidth: 10000,
                maxHeight: 10000
            },
            imageTypeValidator: {
                noAcceptTypeList: ['image/gif']
            },
            ratioValidator: {
                ratio: oneToOneRatio
            }
        }
    },
    three_to_four_item_images: {
        name: 'three_to_four_item_images',
        validate: {
            name: '3:4商品图片',
            validatorNum: 5,
            imageTypeValidator: {
                noAcceptTypeList: ['image/gif']
            },
            rectValidator: {
                minWidth: 750,
                minHeight: 1000,
                maxWidth: 7500,
                maxHeight: 10000
            },
            ratioValidator: {
                ratio: threeToFourRatio,
                ratioDiffScope: 0.001
            },
            sizeValidator: {
                minSize: 0,
                maxSize: 5
            }
        }
    },
    description_old: {
        name: 'description_old',
        validate: {
            rectValidator: {
                maxWidth: 10000,
                maxHeight: 10000
            },
            sizeValidator: {
                minSize: 0,
                maxSize: 20
            }
        }
    },
    wireless_desc: {
        name: 'wireless_desc',
        validate: {
            rectValidator: {
                maxWidth: 10000,
                maxHeight: 10000,
                maxTotalHeight: 35000
            },
            sizeValidator: {
                minSize: 0,
                maxSize: 3
            },
            imageTypeValidator: {
                acceptTypeList: ['image/jpg', 'image/jpeg', 'image/png']
            }
        }
    }
}

// 给铺货模版的配置
export const goodsQuickSets = [validates.item_images, validates.three_to_four_item_images]

// 商品主图、3:4主图、
export default validates
